import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '@/redux/store'
import type { SearchResultItem } from '../search/types'

interface MediaDetailsState {
  openDrawer: boolean
  searchResultItem: SearchResultItem | null
  isLoading: boolean
}

interface ModalState {
  open: boolean
  title: string
  confirm: boolean
}

interface InitialState {
  mediaDetailsState: MediaDetailsState
  modalState: ModalState
}

const initialState: InitialState = {
  mediaDetailsState: {
    openDrawer: false,
    searchResultItem: null,
    isLoading: false,
  },
  modalState: {
    open: false,
    title: '',
    confirm: false,
  },
}

export const mediaDetailsSlice = createSlice({
  name: 'mediaDetails',
  initialState,
  reducers: {
    setMediaDetailsState: (
      state,
      action: PayloadAction<Partial<MediaDetailsState>>,
    ) => {
      state.mediaDetailsState = {
        ...state.mediaDetailsState,
        ...action.payload,
      }
    },
    setModalState: (state, action: PayloadAction<Partial<ModalState>>) => {
      state.modalState = {
        ...state.modalState,
        ...action.payload,
      }
    },
  },
})

export const { setMediaDetailsState, setModalState } = mediaDetailsSlice.actions

export const getMediaDetailsState = (state: RootState) =>
  state.reducer.mediaDetails

export default mediaDetailsSlice.reducer
